export class DaywiseProductionModel{
    batchNo : string
    product : string
    grade : string
    packStyle : string
    saleOrderNum : string
    buyer : string
    fgQtyInKgs : number
    fgYield : number
    packCount : number
    rmCount : number
    rnRatePerKg : number
    rmCostPerKg : number
    mfgCosttPerKg : number
    packingCostPerKg : number
    freightAndForwardExp : number
    totalCostOfSalesPerKg : number
    inInr : number
    costOfSaleLbkgInUsd : number
    SalesRateLbkgInUsd : number
    pLPerKgLbInUsd : number
    incentives : number
    totalPLPerKfLbInUsd : number

    constructor(batchNo : string,product : string,grade : string,packStyle : string,saleOrderNum : string,buyer : string,fgQtyInKgs : number,fgYield : number,packCount : number,rmCount : number,rnRatePerKg : number,rmCostPerKg : number,mfgCosttPerKg : number,packingCostPerKg : number,freightAndForwardExp : number,totalCostOfSalesPerKg : number,inInr : number,costOfSaleLbkgInUsd : number,SalesRateLbkgInUsd : number,pLPerKgLbInUsd : number,incentives : number,totalPLPerKfLbInUsd : number){
    this.batchNo = batchNo
    this.product = product
    this.grade = grade
    this.packStyle = packStyle
    this.saleOrderNum = saleOrderNum
    this.buyer = buyer
    this.fgQtyInKgs = fgQtyInKgs
    this.fgYield = fgYield
    this.packCount = packCount
    this.rmCount = rmCount
    this.rnRatePerKg = rnRatePerKg
    this.rmCostPerKg = rmCostPerKg
    this.mfgCosttPerKg = mfgCosttPerKg
    this.packingCostPerKg = packingCostPerKg
    this.freightAndForwardExp = freightAndForwardExp
    this.totalCostOfSalesPerKg = totalCostOfSalesPerKg
    this.inInr = inInr
    this.costOfSaleLbkgInUsd = costOfSaleLbkgInUsd
    this.SalesRateLbkgInUsd = SalesRateLbkgInUsd
    this.pLPerKgLbInUsd = pLPerKgLbInUsd
    this.incentives = incentives
    this.totalPLPerKfLbInUsd = totalPLPerKfLbInUsd
    }
}